import axiosInstance from '../../../config/axiosInstance';
const  AssetHistoryService = {
    async GetAllAssetNotification(redirectCallback,ID) {
        try {            
            const response = await axiosInstance.get(`/Asset/GetAllAssetNotifications?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetNotificationType(redirectCallback) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Asset/GetNotificationType`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteAssetNotification(redirectCallback,ID) {
        try {            
            const response = await axiosInstance.get(`/Asset/DeleteAssetNotifications?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
};

export default AssetHistoryService;